module.exports = __webpack_public_path__ + "static/img/guide_icon_pic.210f53d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guide_icon_pic.png
// module id = 9ytk
// module chunks = 1